import React from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import {
  setCalendarSheet,
  setLocalTask,
} from '../../store/actions/calendarActions';
import { states } from '../../constants/states';
import { useCalendarDispatch, useCalendarState } from '../../context/CalendarContext';
import commonStyles from '../../Calendar.module.scss';
import styles from './ChangeSheetButton.module.scss';

const ChangeSheetButton = ({ text, icon, period, className, ...props }) => {
  const { calendarSheet, view, localTask, state } = useCalendarState();
  const dispatch = useCalendarDispatch();

  const handleClick = () => {
    if (localTask && state !== states.editTask) {
      dispatch(setLocalTask(null));
    }
    dispatch(setCalendarSheet(period));
  };

  return (
    <Button
      {...props}
      onClick={handleClick}
      className={cn(commonStyles.button, styles.root, className, {
        [styles.active]: !icon && calendarSheet.isSame(period, view),
      })}
    >
      {icon && icon}
      {text && text}
    </Button>
  );
};

export default ChangeSheetButton;
